import { render, staticRenderFns } from "./OtoTab.vue?vue&type=template&id=313dda5e&scoped=true"
import script from "./OtoTab.vue?vue&type=script&lang=js"
export * from "./OtoTab.vue?vue&type=script&lang=js"
import style0 from "./OtoTab.vue?vue&type=style&index=0&id=313dda5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313dda5e",
  null
  
)

export default component.exports